import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "taxshift-cookie-consent-v1";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setShow(true);
  }, []);

  const record = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, timestamp: new Date().toISOString() })
    );
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-foreground text-background border-t-4 border-primary"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col lg:flex-row lg:items-center gap-6">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <span className="font-mono uppercase text-[10px] tracking-[0.3em] bg-primary text-primary-foreground px-2 py-1">
                GDPR Notice
              </span>
              <span className="font-mono text-xs text-background/60 uppercase tracking-widest">
                EU / UK / Global
              </span>
            </div>
            <h3 className="font-heading text-xl font-semibold mb-2">
              Cookies make this site work — and your preferences matter.
            </h3>
            <p className="font-body text-sm text-background/80 leading-relaxed max-w-3xl">
              We use strictly necessary cookies to operate this site, and optional analytics &
              advertising cookies (including Google AdSense) to measure audience and show relevant
              ads. You can accept, reject non-essential cookies, or customize.{" "}
              <Link
                to="/cookie-policy"
                className="underline hover:text-primary"
                data-testid="cookie-learn-more"
              >
                Read the full Cookie Policy
              </Link>
              .
            </p>

            {showDetails && (
              <div className="mt-5 grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-background/20 pt-5">
                <div>
                  <h4 className="font-mono text-xs uppercase tracking-widest text-primary mb-1">
                    Necessary (always on)
                  </h4>
                  <p className="font-body text-xs text-background/70">
                    Session, routing, GDPR consent storage. Cannot be disabled.
                  </p>
                </div>
                <div>
                  <h4 className="font-mono text-xs uppercase tracking-widest text-primary mb-1">
                    Analytics (optional)
                  </h4>
                  <p className="font-body text-xs text-background/70">
                    Aggregate page metrics. No personally identifiable data.
                  </p>
                </div>
                <div>
                  <h4 className="font-mono text-xs uppercase tracking-widest text-primary mb-1">
                    Advertising (optional)
                  </h4>
                  <p className="font-body text-xs text-background/70">
                    Google AdSense shows contextual ads to support free calculators.
                  </p>
                </div>
              </div>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <button
              onClick={() => setShowDetails(!showDetails)}
              className="font-mono uppercase text-xs tracking-widest border border-background/40 text-background/80 px-5 py-3 hover:border-background transition-colors"
              data-testid="cookie-customize"
            >
              {showDetails ? "Hide Details" : "Customize"}
            </button>
            <button
              onClick={() => record("rejected")}
              className="font-mono uppercase text-xs tracking-widest border border-background text-background px-5 py-3 hover:bg-background hover:text-foreground transition-colors"
              data-testid="cookie-reject"
            >
              Reject Non-Essential
            </button>
            <button
              onClick={() => record("accepted")}
              className="font-mono uppercase text-xs tracking-widest bg-primary text-primary-foreground px-5 py-3 hover:brightness-110 transition"
              data-testid="cookie-accept"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
